import { Paper, Box, Typography } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';

interface HeaderRegisterProps {
  title: string;
  description: string;
}

const HeaderRegister = ({ title, description }: HeaderRegisterProps) => {
  return (
    <Paper elevation={1} sx={{ p: 3, mb: 3, backgroundColor: '#002A76', color: 'white' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <BusinessIcon sx={{ fontSize: 40, mr: 2 }} />
        <Box>
          <Typography
            variant='h3'
            fontWeight='bold'
            sx={{
              fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            {title}
          </Typography>
          <Typography
            variant='h6'
            sx={{ opacity: 0.9, mt: 1, fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' } }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default HeaderRegister;
